import { stylesheet } from 'typestyle';
import {
  flexRoot,
  horizontal,
  layerParent,
  newLayer,
  centerCenter
} from 'csstips';
import { linkBlueText } from '@styles/general';

const thumbnailGap = 6;

export default stylesheet({
  container: {
    ...flexRoot,
    ...horizontal,

    marginTop: 12
  },
  thumbnail: {
    ...layerParent,

    width: `calc((100% - (4 * ${thumbnailGap}px)) / 5)`,
    marginLeft: thumbnailGap,

    '&:first-child': {
      marginLeft: 0
    },
    '&.active .thumbnail--image-box': {
      border: `1px solid ${linkBlueText}`
    }
  },
  thumbnailImageContainer: {
    cursor: 'pointer',
    paddingTop: '100%',
    width: '100%'
  },
  thumbnailImageBox: {
    ...newLayer,
    ...horizontal,
    ...centerCenter,

    width: '100%',
    border: '1px solid #e4e3e3'
  },
  thumbnailImage: {
    maxHeight: '95%',
    maxWidth: '95%',

    $nest: {
      '&.video': {
        maxHeight: '50%',
        maxWidth: '50%'
      }
    }
  }
});
